<template>
    <!--Waiting List Notifications Page-->
    <div class="waiting-list-notifications">
        <!--Heading title-->
        <h3>{{ $ml.get("waitingListNotifications.title") }}</h3>
        <div class="wlist-notifications-wrap section-wrap" v-if="!notificationLoaded">
            <p>
                When spots become available, your clients can be notified by Text Message, Email, or In App Push
                Notifications.
            </p>
            <p>Please choose what method you prefer to be used.</p>
            <div class="checkbox-inputs-container">
                <!--SMS-->
                <div class="input-checkbox">
                    <div class="input-box">
                        <input v-model="sms" type="checkbox" id="sms-checkbox" name="SMS" value="sms"
                            @change="updateNotificationPreferences" />
                    </div>
                    <label for="sms-checkbox" class="checkbox-label-wrap" type="button">
                        <span class="checkbox-title">
                            Text Messages ({{ profileCurrency }}{{ costPerSms }} per 100 SMS)
                        </span>
                    </label>
                    <i class="fa fa-info-circle" aria-hidden="true" data-toggle="modal"
                        data-target="#textMessagesMoreInfo"></i>
                </div>
                <!--Emails-->
                <div class="input-checkbox">
                    <div class="input-box">
                        <input v-model="email" type="checkbox" id="email-checkbox" name="Email" value="email"
                            @change="updateNotificationPreferences" />
                    </div>
                    <label for="email-checkbox" class="checkbox-label-wrap" type="button">
                        <span class="checkbox-title">
                            Emails ({{ profileCurrency }}{{ costPerEmail }} per 1000 Emails)
                        </span>
                    </label>
                    <i class="fa fa-info-circle" aria-hidden="true" data-toggle="modal"
                        data-target="#emailMoreInfo"></i>
                </div>
                <!--Push-->
                <div class="input-checkbox">
                    <div class="input-box">
                        <input v-model="push" type="checkbox" id="push-checkbox" name="Push" value="push"
                            @change="updateNotificationPreferences">
                    </div>
                    <label for="push-checkbox" class="checkbox-label-wrap">
                        <span class="checkbox-title">In App Push Notifications (free)</span>
                    </label>
                </div>
                <!--All of the above-->
                <div class="input-checkbox">
                    <div class="input-box">
                        <input v-model="all" type="checkbox" id="all-checkbox" name="All" value="all"
                            @change="updateNotificationPreferences" />
                    </div>
                    <label for="all-checkbox" class="checkbox-label-wrap">
                        <span class="checkbox-title">All of the above</span>
                    </label>
                </div>


            </div>
            <p>Notification message (what is sent to your client when a spot become available). You can edit it.</p>
            <div class="wlist-notification-wrap section-wrap">
                <div class="card-textarea">
                    <textarea class="text-field notificationtext" placeholder="Message" aria-label="Message"
                        v-model="notificationText" maxlength="255"></textarea>
                </div>
                <div class="card-bottom-btns">
                    <span class="main-text-link" @click="restoreDefaultMessage">Restore default message</span>
                    <span class="main-text-link" @click="runTest">Send test</span>
                </div>
            </div>

            <div class="next-step">
                <router-link class="primary-btn extra-small mobile" :to="{ path: '/app/waiting-list/dashboard' }">
                    {{ $ml.get("general.goBack") }}
                </router-link>
                <button :class="selectedNotifications.length == 0 ? 'disabled-button' : ''"
                    @click="saveNotificationPreferences" class="primary-btn extra-small mobile">
                    Save
                </button>
            </div>
        </div>
        <main-loader v-if="notificationLoaded" class="section-wrap"></main-loader>

        <!--SMS modal-->
        <waiting-list-modal id="textMessagesMoreInfo" title="Text Messages (SMS)"
            p1="To ensure your clients receive instant alerts about available spots, we highly recommend text message notifications."
            :p2="`Text message notifications are available in packs of 100 messages for ${ profileCurrency }${costPerPackMethod(costPerSms, 100)} (100 messages x ${ profileCurrency }${ costPerSms }/message).`"
            buttonText="Got it">
        </waiting-list-modal>
        <!--Email modal-->
        <waiting-list-modal id="emailMoreInfo" title="Emails"
            p1="To ensure your clients receive timely alerts about available spots, email notifications are available."
            :p2="`Email notifications are sold in packs of 1,000 emails for ${ profileCurrency }${costPerPackMethod(costPerEmail, 1000)} (1,000 emails x ${ profileCurrency }${costPerEmail} per email).`"
            buttonText="Got it">
        </waiting-list-modal>
    </div>
</template>

<script>
import store from "../../../services/vuex";
import eventBus from "../../../services/event_bus";
import api from "../../../services/api_endpoints";
import messages from "../../../services/messages";
import MainLoader from "../general-components/main_loader.vue";
import WaitingListModal from "./parts/waiting_list_modal.vue";

export default {
    data() {
        return {
            profile: {},
            sms: false,
            email: false,
            push: false,
            all: false,
            profileCurrency: "$",
            costPerSms: 0,
            costPerEmail: 0,
            costPerPack: 0,
            smsAllowedCountries: [],
            selectedNotifications: [],
            notificationText: "",
            notificationLoaded: false,
            notificationTextDefault: "",
            testNotificationText: "",
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return store.state.adminDetails;
            },
            set: function (value) {
                store.commit("setAdminDetails", value);
            },
        },
        waitingListSettings: {
            get: function () {
                return store.state.waitingListSettings;
            },
            set: function (value) {
                store.commit("setWaitingListSettings", value);
            },
        },
    },
    mounted() {
        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        this.smsAllowedCountries = process.env.VUE_APP_SMS_ALLOWED_COUNTRIES.split(",");

        if (store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.$on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });

        this.updateNotificationPreferences();
        this.getWaitingListSubscriptionAndSettings();
    },
    components: {
        MainLoader,
        WaitingListModal
    },
    methods: {
        getStylistProfile() {
            this.profile = this.adminDetails.profile;
        },

        onAdminDetailsLoad: function () {
            if (this.smsAllowedCountries.indexOf(this.adminDetails.profile.country_id.toString()) > -1) {
                this.costPerSms = process.env["VUE_APP_SMS_COST_" + this.adminDetails.profile.country_id];
            } else {
                this.costPerSms = process.env["VUE_APP_SMS_COST_0"];
            }

            this.costPerEmail = process.env["VUE_APP_EMAIL_COST"];
            this.getStylistProfile();
        },

        costPerPackMethod(msgType, pack) {
            return this.costPerPack = (msgType * pack).toFixed(2);
        },
        updateNotificationPreferences() {
            // Reset the array each time the method is called
            this.selectedNotifications = [];

            // Check each option and push the corresponding value to the array
            if (this.sms) {
                this.selectedNotifications.push('sms');
            }
            if (this.email) {
                this.selectedNotifications.push('email');
            }
            if (this.push) {
                this.selectedNotifications.push('push');
            }
            if (this.all) {
                this.selectedNotifications = [];
                this.sms = true;
                this.email = true;
                this.push = true;
                this.selectedNotifications.push('sms', 'email', 'push');
            }

            if (!this.all && !this.sms && !this.email && !this.push) {
                this.selectedNotifications = [];
            }
        },
        getWaitingListSubscriptionAndSettings() {
            this.notificationLoaded = true;

            this.$http.get(api.actions.get_waiting_list_subscription_and_settings).then((response) => {

                if (response.data.error == true) {
                    return;
                }
                this.waitingListSettings = response.body.waitlist_subscription_and_settings;

                this.notificationTextDefault = this.waitingListSettings.notification_txt_default;
                this.notificationTextDefaultClone = this.waitingListSettings.notification_txt_default;

                this.formatNotificationText();

                if (this.waitingListSettings.sms) {
                    this.sms = true;
                    this.selectedNotifications.push('sms');
                }

                if (this.waitingListSettings.email) {
                    this.email = true;
                    this.selectedNotifications.push('email');
                }

                if (this.waitingListSettings.push) {
                    this.push = true;
                    this.selectedNotifications.push('push');
                }

                if (this.waitingListSettings.notification_txt) {
                    this.notificationText = this.waitingListSettings.notification_txt != '' ? this.waitingListSettings.notification_txt : this.notificationTextDefault;
                }

                if (this.waitingListSettings.notification_txt === null || this.waitingListSettings.notification_txt === '') {
                    this.notificationText = this.notificationTextDefault;
                }

                this.notificationLoaded = false;
            });
            return;
        },
        saveNotificationPreferences() {
            let data = {
                type: 'stylist',
                sms: this.selectedNotifications.indexOf('sms') != -1 ? 1 : 0,
                email: this.selectedNotifications.indexOf('email') != -1 ? 1 : 0,
                push: this.selectedNotifications.indexOf('push') != -1 ? 1 : 0,
                notification_txt: this.notificationText,
            };

            this.$http.post(api.actions.save_waiting_list_settings, data).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                messages.successMessage(messages.GLOBAL_MESSAGES.WAITING_LIST_NOTIFICATION_PREFERENCES);
            });
            return;
        },
        restoreDefaultMessage() {
            this.notificationText = this.notificationTextDefault;
        },
        runTest() {
            let data = {
                to_user_id: this.adminDetails.user.id,
                text: this.notificationText == this.notificationTextDefault ? this.testNotificationText : this.notificationText,
            };
            
            this.$http.post(api.actions.send_sms, data).then((res) => {
                if (!res.data.error) {
                    messages.successMessage(messages.GLOBAL_MESSAGES.MESSAGE_SENT);
                }
            });
        },
        formatNotificationText() {
            const now = new Date();

            const formattedDate = now.toLocaleDateString("en-US");
            const formattedTime = now.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit' });

            this.testNotificationText = this.notificationTextDefault
                .replace(/\[SERVICE\]/g, "Demo service")
                .replace(/\[DATE\]/g, formattedDate)
                .replace(/\[TIME\]/g, formattedTime)
                .replace(/\[DOWNLOAD_APP\]/g, this.generalOptions.site_url
                .replace('www.', '') + 'openapp');
        }
    },
}
</script>
